import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27c99b5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "数据统计")
], -1))
const _hoisted_2 = { class: "tool-bar" }

import BaseEchart from '@/components/BaseEchart.vue'
import { onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { getListData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeEchart',
  setup(__props) {

const options = ref<any>({})
const months: any = ref([])
const columns = ref([
  {
    prop: 'orderCount',
    sqlCol: 'order_count',
    label: '成交单量',
    type: 'option'
  },
  {
    prop: 'amountCount',
    sqlCol: 'amount_count',
    label: '成交金额',
    type: 'option'
  }
])

const currentOption = ref('order_count')
const dataMap: any = ref({})
const personalData: any = ref([])
const groupData: any = ref([])
const companyData: any = ref([])

let loadingInstance: ILoadingInstance = {} as ILoadingInstance
const getOptions = () => {
  let currentMonth = dayjs().month()
  let beginMonth = currentMonth - 6
  months.value = []
  personalData.value = []
  for (let i = beginMonth; i < currentMonth; i++) {
    months.value.push(i + 1 + '月份')
    personalData.value.push({ month: i + 1, valueStr: 0 })
    companyData.value.push({ month: i + 1, valueStr: 0 })
    groupData.value.push({ month: i + 1, valueStr: 0 })
  }
  loadingInstance = ElLoading.service({
    target: '.exchangeChart'
  })
  getListData('/main/order/statistic', {
    columnName: currentOption.value
  }).then((res) => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    dataMap.value = res
    dataMap.value.personalData.forEach((item: any) => {
      personalData.value.filter((item2: any) => {
        if (item2.month == item.month) {
          item2.valueStr = parseFloat(item.valueStr)
        }
      })
    })
    dataMap.value.groupData.forEach((item: any) => {
      groupData.value.filter((item2: any) => {
        if (item2.month == item.month) {
          item2.valueStr = parseFloat(item.valueStr)
        }
      })
    })
    dataMap.value.companyData.forEach((item: any) => {
      companyData.value.filter((item2: any) => {
        if (item2.month == item.month) {
          item2.valueStr = parseFloat(item.valueStr)
        }
      })
    })
    options.value = {
      tooltip: {
        trigger: 'axis',
        className: 'echarts-tooltip',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: months
      },
      yAxis: {
        type: 'value'
      },
      legend: {},
      series: [
        {
          name: '个人',
          data: personalData.value.map((item: any) => item.valueStr),
          type: 'bar'
        },
        {
          name: '全组',
          data: groupData.value.map((item: any) => item.valueStr),
          type: 'bar'
        },
        {
          name: '公司',
          data: companyData.value.map((item: any) => item.valueStr),
          type: 'bar'
        }
      ]
    }
  })
}

onMounted(() => {
  getOptions()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          style: {"width":"110px"},
          modelValue: currentOption.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentOption).value = $event)),
          size: "mini",
          onChange: getOptions,
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.sqlCol,
                label: item.label,
                value: item.sqlCol
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    default: _withCtx(() => [
      (options.value)
        ? (_openBlock(), _createBlock(BaseEchart, {
            key: 0,
            class: "exchangeChart",
            options: options.value
          }, null, 8, ["options"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})